import apiClient from './apiClient';
import { connectWallet, signMessage } from './web3Provider';

export const AUTH_ACTIONS = {
  REGISTER: 'register',
  LOGIN: 'login',
};

export const authService = {
  getNonce(address, action) {
    return apiClient
      .get('/auth/nonce', { params: { address, action } })
      .then((res) => res.data);
  },

  verify(address, signature, action, username, referralCode) {
    const body = { address, signature, action };
    if (username) {
      body.username = username;
    }
    if (referralCode) {
      body.referralCode = referralCode;
    }
    return apiClient.post('/auth/verify', body).then((res) => res.data);
  },

  getMe() {
    return apiClient.get('/auth/me').then((res) => res.data);
  },

  authenticate(action, username, referralCode) {
    return connectWallet().then((address) =>
      this.getNonce(address, action).then(({ message }) =>
        signMessage(message, address).then((signature) =>
          this.verify(address, signature, action, username, referralCode)
        )
      )
    );
  },
};
